/*
 * @Author: zhaotianxiong
 * @LastEditors: zhaotianxiong
 * @Date: 2020-03-23 16:58:22
 * @LastEditTime: 2020-03-23 18:24:55
 * @Description: FormCheckbox
 * @FilePath: \src\form-checkbox\index.tsx
 * @karakal
 */

import React from 'react';
import { Form, Checkbox } from 'antd';
import classNames from 'classnames';
import { WrappedFormUtils } from 'antd/lib/form/Form';

interface ICheckboxItem {
    label: any;
    value: any;
}

interface IFormCheckboxProps {
    /** 字段的英文key */
    field: string;
    form: any;
    className: string;
    initialValue: any;
    readOnly: boolean;
    options: Array<ICheckboxItem>;
    render: any;
    label: any;
    labelCol: any;
    wrapperCol: any;
}

const FormCheckbox = (props: IFormCheckboxProps) => {
    const {
        form,
        className,
        field,
        initialValue,
        readOnly,
        render,
        options,
        label,
        labelCol,
        wrapperCol,
    } = props;
    const { getFieldDecorator, getFieldValue, setFieldsValue } = form as WrappedFormUtils;

    const onChange = (value: any) => {
        setFieldsValue({ [field]: value });
    };

    return (
        <Form.Item
            {...{
                label,
                labelCol,
                wrapperCol,
            }}
            className={classNames('rac_form_input', className)}
        >
            {getFieldDecorator(field, {
                initialValue,
            })(
                readOnly ? (
                    render ? (
                        render(getFieldValue(field))
                    ) : (
                        <span>{getFieldValue(field)}</span>
                    )
                ) : (
                    <Checkbox.Group
                        style={{ width: '100%' }}
                        options={options}
                        onChange={(value: any) => {
                            onChange(value);
                        }}
                    ></Checkbox.Group>
                )
            )}
        </Form.Item>
    );
};

export default FormCheckbox;
